import React from 'react'
import ResultsSection, { NotAvailable } from './ResultsSection'
import useCareerExploration from './CareerExplorationProvider'

const RelatedOccupationsSection = ({ career, ...props }) => {
  const { related } = career
  if (!related.length)
    return (
      <NotAvailable section="related_occupations" career={career} {...props} />
    )

  return (
    <ResultsSection section="related_occupations" career={career} {...props}>
      <div className="flex flex-col gap-2">
        {related.map((relatedItem, idx) => (
          <RelatedOccupation
            key={`related-occupation${idx}`}
            relatedItem={relatedItem}
          />
        ))}
      </div>
    </ResultsSection>
  )
}

export default RelatedOccupationsSection

const RelatedOccupation = ({ relatedItem }) => {
  const { formatMoneyAmt } = useCareerExploration()
  const { salary, path_url, name } = relatedItem
  return (
    <div>
      <span>{formatMoneyAmt(salary)}</span> - <a href={path_url}>{name}</a>
    </div>
  )
}
